import { guid } from "../../core/helpers/string-util.js";
import Model from "../Model.js";

/**
 * `componentNode` represents an abstract node in the components tree of a
 * keyFigure.
 *
 * @abstract
 * @param {string} spec.id - Unique identifier of the component
 * @param {string} spec.valueType - Type of the component value
 * @param {string} spec.name - Name of the component
 * @param {integer} [spec.numberOfDecimals] - The number of decimals the values of this key figure should have
 */
export default class ComponentNode extends Model {
	constructor(spec = {}) {
		super(spec);
		this._id = spec.id || guid();
		this._valueType = spec.valueType || "Amount";
		this._name = spec.name;
		this._numberOfDecimals = spec.numberOfDecimals || 2;
	}

	getId() {
		return this._id;
	}

	getNumberOfDecimals() {
		return this._numberOfDecimals;
	}

	getName() {
		return this._name;
	}

	setName(name) {
		this._name = name;
	}

	getValueType() {
		return this._valueType;
	}

	setValueType(valueType) {
		this._valueType = valueType;
	}

	isKeyFigure() {
		return false;
	}

	isPercentage() {
		return this.getValueType() === "Percent";
	}

	_serializedProperties() {
		return {
			id: this._id,
			valueType: this._valueType,
			name: this._name,
			type: this.constructor.getType(),
		};
	}

	static getType() {
		return this._subclassResponsibility();
	}
}
